
/**
 * IBKUL Kids Size Labels
 * Activated via product tag: kids-size-label
 * Display only — Shopify variant values remain unchanged.
 */
(() => {
  'use strict';

  const sizes = {
    S: 'S / 8',
    M: 'M / 10',
    L: 'L / 12',
    XL: 'XL / 14'
  };

  // Inject CSS once
  const style = document.createElement('style');
  style.id = 'ibkul-kids-size-labels-style';
  style.textContent = `
    [option-name="Size"] .swatch-button {
      min-width: 68px !important;
    }

    [option-name="Size"] .swatch-button-title-text span {
      white-space: nowrap !important;
    }

    input.m-product-option__input[name^="Size"] +
    .m-product-option--node__label {
      min-width: 68px;
      white-space: nowrap;
    }
  `;

  if (!document.getElementById(style.id)) {
    document.head.appendChild(style);
  }

  let scheduled = false;

  function update() {
    scheduled = false;

    // Swatch King size buttons
    document.querySelectorAll(
      '[option-name="Size"] .swatch-button[orig-value]'
    ).forEach(button => {
      const size = button.getAttribute('orig-value');
      const display = sizes[size];

      if (!display) return;

      const label = button.querySelector(
        '.swatch-button-title-text span'
      );

      if (label && label.textContent.trim() !== display) {
        label.textContent = display;
      }

      const item = button.closest('.swatch-view-item');

      if (item) {
        const aria = item.classList.contains(
          'swatch-item-unavailable'
        ) ? `${display} - Sold Out` : display;

        if (item.getAttribute('aria-label') !== aria) {
          item.setAttribute('aria-label', aria);
        }
      }
    });

    // Selected size beside Size heading
    document.querySelectorAll(
      '[option-name="Size"] .swatch-variant-name'
    ).forEach(el => {
      const selected = el.closest('[option-name="Size"]')
        ?.querySelector(
          '.swatch-view-item[aria-checked="true"] ' +
          '.swatch-button[orig-value]'
        );

      const size = selected?.getAttribute('orig-value');
      const display = sizes[size];

      if (!display) return;

      const text = [...el.childNodes].find(
        node => node.nodeType === Node.TEXT_NODE &&
                node.nodeValue.trim()
      );

      if (text && text.nodeValue.trim() !== display) {
        text.nodeValue = ` ${display}`;
      }
    });

    // Native Minimog fallback
    document.querySelectorAll(
      'input.m-product-option__input[type="radio"]'
    ).forEach(input => {
      if (!input.name.toLowerCase().startsWith('size')) return;

      const display = sizes[input.value.trim()];
      if (!display || !input.id) return;

      const label = document.querySelector(
        `label[for="${CSS.escape(input.id)}"]`
      );

      if (!label) return;

      const text = [...label.childNodes].find(
        node => node.nodeType === Node.TEXT_NODE &&
                node.nodeValue.trim()
      );

      if (text && text.nodeValue.trim() !== display) {
        text.nodeValue = display;
      }
    });

    // Sticky Add to Cart
    document.querySelectorAll(
      'select[id^="atcVariantSelect-"] option'
    ).forEach(option => {
      const updated = option.textContent.replace(
        /\/\s*(S|M|L|XL)\s*-/g,
        (_, size) => `/ ${sizes[size]} -`
      );

      if (option.textContent !== updated) {
        option.textContent = updated;
      }
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  document.addEventListener('shopify:section:load', schedule);

  // Handle Swatch King re-rendering
  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();
